export default __webpack_public_path__ + "static/media/AirCargo.be04bc08.png";